import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './styles/history.css';
import Navbar from "../navigation/Navbar";
import { mainGet, mainPost } from "../../domain/net/mainApi";
/* eslint-disable react-hooks/exhaustive-deps */

const HISTORY_PAGE_SIZE = 20;

function addTimes(timeArray) {
    let mins = timeArray.reduce((acc, time) => {
        let [h, m] = time.split('.');
        acc += h * 60 + m * 1;
        return acc;
    }, 0);
    return (mins / 60 | 0) + '.' + ('0' + (mins % 60)).slice(-2);
}

const isSessionCompleted = (session) => {
    const now = new Date();
    const sessionDate = new Date(session.date);
    return session.state === '1' && now > sessionDate;
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
        dayOfWeek: date.toLocaleDateString('ru-RU', { weekday: 'long' }),
        formatted: date.toLocaleDateString('ru-RU')
    };
};

const groupSessionsByDate = (sessions) => {
    return sessions.reduce((acc, session) => {
        acc[session.date] = [...(acc[session.date] || []), session];
        return acc;
    }, {});
};

const mergeCalendarGroups = (currentCalendar, newCalendar) => {
    const merged = { ...currentCalendar };

    Object.entries(newCalendar).forEach(([date, sessions]) => {
        merged[date] = [...(merged[date] || []), ...sessions];
    });

    return merged;
};

// Sub-components
const InfoRow = ({ label, value, empty = false, multiline = false }) => (
    <div className="info-row">
        <span className="info-row__label">{label}:</span>
        {multiline ? (
            <p className={`info-row__value ${empty ? 'info-row__value--empty' : ''}`}>
                {value}
            </p>
        ) : (
            <span className={`info-row__value ${empty ? 'info-row__value--empty' : ''}`}>
        {value}
      </span>
        )}
    </div>
);

const FormSelect = ({ label, value, onChange, options }) => (
    <div className="form-field">
        <label className="form-field__label">{label}:</label>
        <select
            className="form-field__select"
            value={value}
            onChange={(e) => onChange(e.target.value)}
        >
            {options.map(option => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>
);

const FormTextarea = ({ label, value, onChange, placeholder }) => (
    <div className="form-field">
        <label className="form-field__label">{label}:</label>
        <textarea
            className="form-field__textarea"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            rows={4}
        />
    </div>
);

const StudentView = ({ session }) => (
    <div className="session-info">
        <InfoRow label="Тренер" value={session.coach} />
        <InfoRow label="Оценка" value={session.mark || 'Не указана'} empty={!session.mark} />
        <InfoRow
            label="Время"
            value={`${session.time} - ${addTimes([session.time, session.duration])}`}
        />
        <InfoRow
            label="Комментарий"
            value={session.comment || 'Отсутствует'}
            empty={!session.comment}
            multiline
        />
    </div>
);

const CoachView = ({
                       session,
                       isActive,
                       formData,
                       onFormChange,
                       onSave,
                       onCancel,
                       loading
                   }) => (
    <div className="session-info">
        <InfoRow label="Ученик" value={session.student} />
        <InfoRow
            label="Время"
            value={`${session.time} - ${addTimes([session.time, session.duration])}`}
        />
        <InfoRow label="Цена" value={`${session.price} ₽`} />

        {isActive ? (
            <div className="session-form">
                <FormSelect
                    label="Присутствие"
                    value={formData.was || session.was}
                    onChange={(value) => onFormChange('was', value)}
                    options={[
                        { value: '', label: 'Опции', disabled: true },
                        { value: 'Была', label: 'Была' },
                        { value: 'Не была', label: 'Не была' }
                    ]}
                />

                <FormSelect
                    label="Оценка"
                    value={formData.mark || session.mark}
                    onChange={(value) => onFormChange('mark', value)}
                    options={[
                        { value: '', label: 'Оценка', disabled: true },
                        { value: '5', label: '5' },
                        { value: '4', label: '4' },
                        { value: '3', label: '3' },
                        { value: '2', label: '2' }
                    ]}
                />

                <FormTextarea
                    label="Комментарий тренера"
                    value={formData.comment || session.comment}
                    onChange={(value) => onFormChange('comment', value)}
                    placeholder="Комментарий"
                />

                <div className="form-actions">
                    <button
                        className="btn btn--primary"
                        onClick={onSave}
                        disabled={loading}
                    >
                        {loading ? 'Сохранение...' : 'Сохранить'}
                    </button>
                    <button className="btn btn--secondary" onClick={onCancel}>
                        Отмена
                    </button>
                </div>
            </div>
        ) : (
            <>
                <InfoRow label="Присутствие" value={session.was || 'Не указано'} empty={!session.was} />
                <InfoRow label="Оценка" value={session.mark || 'Не указана'} empty={!session.mark} />
                <InfoRow
                    label="Комментарий"
                    value={session.comment || 'Отсутствует'}
                    empty={!session.comment}
                    multiline
                />
            </>
        )}
    </div>
);

const SessionCard = ({
                         session,
                         user,
                         isActive,
                         formData,
                         onEdit,
                         onFormChange,
                         onSave,
                         onCancel,
                         loading
                     }) => {
    const completed = isSessionCompleted(session);
    const isCancelled = session.state !== '1';

    return (
        <div className={`session-card ${isCancelled ? 'session-card--cancelled' : ''}`}>
            <div className="session-card__status">
                {isCancelled ? (
                    <span className="status status--cancelled">Занятие отменено</span>
                ) : completed ? (
                    <span className="status status--completed">Занятие завершено</span>
                ) : null}
            </div>

            {user.role === 'student' ? (
                <StudentView session={session} />
            ) : (
                <CoachView
                    session={session}
                    isActive={isActive}
                    formData={formData}
                    onFormChange={onFormChange}
                    onSave={onSave}
                    onCancel={onCancel}
                    loading={loading}
                />
            )}

            {user.role !== 'student' && !isActive && (
                <button className="btn btn--outline" onClick={onEdit}>
                    Редактировать
                </button>
            )}
        </div>
    );
};

// Main Component
const History = () => {
    const [calendar, setCalendar] = useState({});
    const [user, setUser] = useState(null);
    const [activeSession, setActiveSession] = useState(null);
    const [formData, setFormData] = useState({ was: '', mark: '', comment: '' });
    const [loading, setLoading] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);

    const getUser = async () => {
        try {
            const clid = localStorage.getItem('clid');
            const key = localStorage.getItem('key');
            const response = await mainGet({ type: 'checkuser', id: clid, pass: key });

            if (response.data.ok) {
                setUser(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        }
    };

    const fetchHistory = async (page = 1, append = false) => {
        if (!user) return;

        if (append) setLoadingMore(true);
        else setHistoryLoading(true);

        try {
            const today = new Date().toISOString().split('T')[0];
            const response = await mainGet({
                type: 'gethistory',
                user: `${user.name} ${user.sname}`,
                role: user.role,
                today,
                page,
                limit: HISTORY_PAGE_SIZE
            });

            if (response.data.ok) {
                const sessions = response.data.data || [];
                const groupedByDate = groupSessionsByDate(sessions);

                setCalendar(prev =>
                    append ? mergeCalendarGroups(prev, groupedByDate) : groupedByDate
                );
                setCurrentPage(page);
                setHasMore(Boolean(response.data.hasMore));
            } else if (!append && response.data.type === 'history empty') {
                setCalendar({});
                setHasMore(false);
            }
        } catch (error) {
            console.error('Error fetching history:', error);
        } finally {
            if (append) setLoadingMore(false);
            else setHistoryLoading(false);
        }
    };

    const updateSession = async (sessionId) => {
        setLoading(true);
        try {
            const response = await mainPost({ type: 'updHist' }, {
                dayId: sessionId,
                was: formData.was,
                mark: formData.mark,
                comment: formData.comment
            });

            if (response.data.ok) {
                await fetchHistory(1, false);
                setActiveSession(null);
                setFormData({ was: '', mark: '', comment: '' });
            } else {
                alert('Произошла ошибка при сохранении');
            }
        } catch (error) {
            console.error('Error updating session:', error);
            alert('Произошла ошибка при сохранении');
        } finally {
            setLoading(false);
        }
    };

    const handleFormChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    useEffect(() => {
        getUser();
    }, []);

    useEffect(() => {
        if (user) {
            fetchHistory(1, false);
        }
    }, [user]);

    const handleLoadMore = async () => {
        if (!hasMore || loadingMore) return;
        await fetchHistory(currentPage + 1, true);
    };

    if (!user || historyLoading) {
        return (
            <div className="history">
                <div className="history__container">
                    <div className="history__loading">
                        <p>Загрузка...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="history">
            <Helmet>
                <title>История занятий</title>
                <link rel="shortcut icon" href="/logo.png" />
            </Helmet>

            <div className="history__container">
                <header className="history__header">
                    <h1 className="history__title">История занятий</h1>
                    {user.role === 'student' && (
                        <p className="history__notice">
                            История занятий за сегодняшний день появится завтра.
                        </p>
                    )}
                </header>

                <div className="history__content">
                    {Object.keys(calendar).length === 0 ? (
                        <div className="history__empty">
                            <p>Нет данных о занятиях</p>
                        </div>
                    ) : (
                        Object.entries(calendar).map(([date, sessions]) => {
                            const { dayOfWeek, formatted } = formatDate(date);

                            return (
                                <div key={date} className="history__day">
                                    <div className="history__date-header">
                                        <h2 className="history__day-name">{dayOfWeek}</h2>
                                        <p className="history__date">{formatted}</p>
                                    </div>

                                    <div className="history__sessions">
                                        {sessions.map((session) => (
                                            <SessionCard
                                                key={session.id}
                                                session={session}
                                                user={user}
                                                isActive={activeSession === session.id}
                                                formData={formData}
                                                onEdit={() => setActiveSession(session.id)}
                                                onFormChange={handleFormChange}
                                                onSave={() => updateSession(session.id)}
                                                onCancel={() => {
                                                    setActiveSession(null);
                                                    setFormData({ was: '', mark: '', comment: '' });
                                                }}
                                                loading={loading}
                                            />
                                        ))}
                                    </div>
                                </div>
                            );
                        })
                    )}

                    {hasMore && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
                            <button
                                className="btn btn--primary"
                                onClick={handleLoadMore}
                                disabled={loadingMore}
                            >
                                {loadingMore ? 'Загрузка...' : 'Загрузить еще'}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <Navbar usertype={user.role} />
        </div>
    );
};

export default History;